<template>
  <div class="content">
    <div class="modal-header border-0 custom-modal-header">
      <div class="page-title">
        <h4>Owner Collection</h4>
      </div>
      <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">×</span>
      </button>
    </div>
    <div class="modal-body custom-modal-body">
      <div class="card">
        <div class="card-body">
          <!-- Loading state -->
          <div v-if="initialLoading" class="text-center py-4">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-2">Loading balance information...</p>
          </div>

          <!-- Main content -->
          <div v-else>
            <!-- Balance Information -->
            <div class="mb-3">
              <div class="alert alert-info mb-3">
                <p>Total Available Balance: <strong>${{ formatNumber(shopBalance.available_balance) }}</strong></p>
              </div>
            </div>

            <!-- Withdrawal Form -->
            <form @submit.prevent="processWithdrawal">
              <div class="row">
                <div class="mb-3">
                  <label class="form-label">Withdrawal Amount</label>
                  <div class="input-group">
                    <span class="input-group-text">$</span>
                    <input
                      type="number"
                      v-model="form.amount"
                      step="0.01"
                      class="form-control"
                      :class="{ 'is-invalid': errors.amount }"
                      placeholder="0.00"
                      :disabled="loading"
                    >
                  </div>
                  <div v-if="errors.amount" class="text-danger">
                    {{ errors.amount[0] }}
                  </div>
                </div>

                <div class="mb-3">
                  <label class="form-label">Withdrawal Date</label>
                  <input
                    type="date"
                    v-model="form.withdrawal_date"
                    class="form-control"
                    :class="{ 'is-invalid': errors.withdrawal_date }"
                    :disabled="loading"
                  >
                  <div v-if="errors.withdrawal_date" class="text-danger">
                    {{ errors.withdrawal_date[0] }}
                  </div>
                </div>
              </div>

              <div class="modal-footer-btn">
                <button type="button" class="btn btn-cancel me-2" data-bs-dismiss="modal">Cancel</button>
                <button
                  type="submit"
                  class="btn btn-submit"
                  :disabled="loading"
                >
                  <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status"></span>
                  {{ loading ? 'Processing...' : 'Process Withdrawal' }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { showSuccessMessage, showErrorMessage } from '../utils/notifications.js';

export default {
  name: 'WithdrawIncome',

  data() {
    return {
      form: {
        amount: '',
        withdrawal_date: new Date().toISOString().split('T')[0]
      },
      shopBalance: {
        available_balance: 0
      },
      errors: {},
      loading: false,
      initialLoading: true
    };
  },

  async mounted() {
    console.log('WithdrawIncome component mounted');

    // Mark element as mounted
    this.$el.closest('[data-vue-component]')?.classList.add('vue-mounted');

    await this.loadShopBalance();
    this.initialLoading = false;
  },

  methods: {
    async loadShopBalance() {
      try {
        const response = await this.$http.get('/api/withdrawals/balance');

        if (response.data.success) {
          this.shopBalance = response.data.data;
        } else {
          this.showErrorMessage(response.data.message || 'Failed to load balance information');
        }
      } catch (error) {
        console.error('Failed to load shop balance:', error);
        this.showErrorMessage('Failed to load balance information');
      }
    },

    async processWithdrawal() {
      this.loading = true;
      this.errors = {};

      try {
        const response = await this.$http.post('/api/withdrawals', this.form);

        if (response.data.success) {
          this.showSuccessMessage(response.data.message);

          // Reset form
          this.form.amount = '';

          // Close modal and redirect
          setTimeout(() => {
            const modal = bootstrap.Modal.getInstance(document.getElementById('add-withdraw'));
            if (modal) {
              modal.hide();
            }
            // Redirect to withdrawals index
            window.location.href = '/account/withdrawals';
          }, 1500);
        } else {
          this.showErrorMessage(response.data.message || 'Failed to process withdrawal');
        }

      } catch (error) {
        console.error('Withdrawal processing failed:', error);

        if (error.response?.status === 422) {
          this.errors = error.response.data.errors || {};
          this.showErrorMessage('Please check the form for errors');
        } else {
          this.showErrorMessage(
            error.response?.data?.message || 'An error occurred while processing the withdrawal'
          );
        }
      } finally {
        this.loading = false;
      }
    },

    formatNumber(value) {
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value || 0);
    },

    showSuccessMessage,
    showErrorMessage
  }
};
</script>

<style scoped>
.spinner-border-sm {
  width: 1rem;
  height: 1rem;
}

.vue-component-loading {
  display: none;
}
</style>
